import React from 'react';
import { useParams } from 'react-router-dom';
import ServicePage from './ServicePage';
import GSTCalculator from './GSTCalculator';

const ServicePageWrapper = () => {
    const { serviceName } = useParams();
    // decodeURIComponent is handled automatically by react-router for params usually, 
    // but just in case, we use the raw param.
    // However, we need to make sure the service name matches the keys in serviceDetails.js

    // Check if the requested service is the GST Calculator
    if (serviceName === 'GST Calculator' || serviceName === 'gst-calculator') {
        return <GSTCalculator />;
    }

    return <ServicePage service={serviceName} />;
};

export default ServicePageWrapper;
